import { ConfigurationComponent } from './configuration.component';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { AppInitConfigService } from './app-init-config.service';
import { ConfigurationService } from './configuration.service';

export interface ConfigModuleOptions {
  env: any;
}

// factory for APP_INITIALIZER
export function initConfigFactory(appInit: AppInitConfigService, options: ConfigModuleOptions) {
  return () => appInit.Init();
}

@NgModule({
  declarations: [
    ConfigurationComponent
  ],
  imports: [],
  exports: [
    ConfigurationComponent
  ]
})

export class ConfigurationModule {
  static forRoot(options: ConfigModuleOptions): ModuleWithProviders<ConfigurationModule> {
    return {
      ngModule: ConfigurationModule,
      providers: [
        ConfigurationService,
        AppInitConfigService,
        { provide: 'env', useValue: options.env },
        {
          provide: APP_INITIALIZER,
          useFactory: initConfigFactory,
          deps: [AppInitConfigService, 'env'],
          multi: true
        }
      ]
    };
  }
}
